import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function ClosingSection() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-14 px-6 text-center border-t border-[var(--border-subtle)]" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-47">
      <div className="max-w-[680px] mx-auto space-y-5" data-id="element-48">
        <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase" data-id="element-49">
          El Cierre
        </p>

        <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] leading-snug" data-id="element-50">
          Llevas demasiado tiempo cargando esto solo.
        </h2>

        <div className="space-y-3 text-lg text-[var(--text-muted)] font-light" data-id="element-51">
          <p data-id="element-52">
            Demasiadas noches sin dormir. Demasiadas oraciones que sintieron
            como si chocaran contra un muro. Demasiados días fingiendo que estás
            bien cuando por dentro todo está colapsando.
          </p>
          <p className="text-[var(--text-primary)] font-serif italic text-xl" data-id="element-53">
            <strong className="not-italic font-bold text-[var(--text-heading)]" data-id="element-54">
              Este es tu momento.
            </strong>
          </p>
        </div>

        <div className="w-16 h-px bg-[var(--accent)] mx-auto opacity-40" data-id="element-55"></div>

        <p className="text-[var(--text-muted)] leading-relaxed" data-id="element-56">
          No para "intentarlo una vez más". Sino para finalmente entender lo que
          está pasando. Para tener el mapa. Para dejar de sufrir a ciegas y
          empezar a caminar con propósito dentro de tu proceso.
        </p>

        <p className="text-[var(--text-muted)] leading-relaxed" data-id="element-57">
          Dios no te puso en el desierto para que mueras ahí.
        </p>

        <p className="text-[var(--accent)] font-bold tracking-widest uppercase text-sm" data-id="element-58">
          Te puso ahí porque confía en que eres capaz de salir diferente.
        </p>

        <div className="pt-4 space-y-3" data-id="element-59">
          <p className="font-serif italic text-[var(--text-heading)] text-xl" data-id="element-60">
            Y este manual es la brújula que te faltaba.
          </p>

          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="mt-4 inline-flex items-center gap-2 px-10 py-4 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#faf7f2] font-extrabold text-base rounded-lg shadow-md uppercase tracking-wide" data-id="element-61">
            <Lock className="w-4 h-4" data-id="element-62" />→ SÍ. QUIERO MI COPIA AHORA.
          </motion.button>

          <p className="text-xs text-[var(--text-muted)] tracking-wider uppercase" data-id="element-63">
            Acceso inmediato · Garantía 7 días · Sin riesgo
          </p>
        </div>
      </div>
    </section>;
}